import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

export enum ANCHAIN_POSSIBLE_KEYS {
  REASON = 'reason',
  SENDING_RISK_LEVEL = 'sendingRiskLevel',
  SENDING_RISK_SCORE = 'sendingRiskScore',
  SENDING_CATEGORIES = 'sendingCategories',
  RECEIVING_RISK_LEVEL = 'receivingRiskLevel',
  RECEIVING_RISK_SCORE = 'receivingRiskScore',
  RECEIVING_CATEGORIES = 'receivingCategories',
}

const parseAnchainResponse = (response: any) => {
  const result: any = {};

  if (response) {
    Object.values(ANCHAIN_POSSIBLE_KEYS).forEach((possibleKey) => {
      if (Object.keys(response).includes(possibleKey)) {
        result[possibleKey] = response[possibleKey];
      }
    });
  }

  return result;
};

const getAnchainFieldTitle = (key: string) => {
  switch (key) {
    case ANCHAIN_POSSIBLE_KEYS.REASON:
      return 'Reason';
    case ANCHAIN_POSSIBLE_KEYS.SENDING_RISK_LEVEL:
      return 'Sending risk level';
    case ANCHAIN_POSSIBLE_KEYS.SENDING_RISK_SCORE:
      return 'Sending risk score';
    case ANCHAIN_POSSIBLE_KEYS.SENDING_CATEGORIES:
      return 'Sending categories';
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_RISK_LEVEL:
      return 'Receiving risk level';
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_RISK_SCORE:
      return 'Receiving risk score';
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_CATEGORIES:
      return 'Receiving categories';
    default:
      return key;
  }
};

const getAnchainFieldIcon = (key: string) => {
  switch (key) {
    case ANCHAIN_POSSIBLE_KEYS.SENDING_RISK_LEVEL:
    case ANCHAIN_POSSIBLE_KEYS.SENDING_RISK_SCORE:
    case ANCHAIN_POSSIBLE_KEYS.SENDING_CATEGORIES:
      return <ArrowRightCircleIcon />;
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_RISK_LEVEL:
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_RISK_SCORE:
    case ANCHAIN_POSSIBLE_KEYS.RECEIVING_CATEGORIES:
      return <ArrowLeftCircleIcon />;
    default:
      return <InformationCircleIcon />;
  }
};

export { parseAnchainResponse, getAnchainFieldTitle, getAnchainFieldIcon };
